


























































































































































import { isFood } from '@/utils'
import moment from 'moment'

import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter, State } from 'vuex-class'

import {
  BusinessUnit,
  Invoice,
  InvoiceStatus,
  Order,
  OrderItem,
  OrderOption,
  OrderStatus,
  OrderType,
  PaymentMethodEnum
} from '../models'

@Component
export default class PrintReceipt extends Vue {
  @Prop({ type: Object, default: null })
  readonly order!: Order | null

  @Prop({ type: Object, required: true })
  readonly invoice!: Invoice

  PaymentMethodTexts: { [key in PaymentMethodEnum]: string } = {
    [PaymentMethodEnum.CASH]: 'Dinheiro',
    [PaymentMethodEnum.CREDIT_CARD]: 'Cartão de crédito',
    [PaymentMethodEnum.DEBIT_CARD]: 'Cartão de débito',
    [PaymentMethodEnum.ONLINE]: 'Online'
  }

  get location () {
    const locations = this.order
      ? this.orderLocations(this.order)
      : this.invoiceLocations(this.invoice)

    return locations?.join('. ') || null
  }

  get didPay () {
    return this.invoice.status === InvoiceStatus.CLOSED
  }

  get hasOneOrder () {
    return this.orders.length === 1
  }

  get orders () {
    return this.order
      ? [this.order]
      : this.ordersByInvoiceId(this.invoice.id)
  }

  get received () {
    if (this.invoice !== null && this.showChange) {
      return this.invoice.change !== null
        ? this.invoice.change
        : this.invoice.total
    }

    return 0
  }

  get showChange () {
    return this.invoice.status !== InvoiceStatus.OPEN
  }

  get isClosed () {
    return this.invoice.status === InvoiceStatus.CLOSED
  }

  get isDelivery () {
    return this.orders[0]?.type === OrderType.DELIVERY
  }

  get methodText () {
    if (this.invoice.paymentMethod) {
      return this.PaymentMethodTexts[this.invoice.paymentMethod]
    }

    return this.isClosed
      ? 'Confirmado'
      : 'Em aberto'
  }

  get isTimeDifferent () {
    if (this.order) {
      return moment(this.order.createdAt)
        .diff(moment(this.invoice.createdAt), 'minutes') >= 5
    }
    return false
  }

  get receiptTitle () {
    return isFood() ? 'Filazero Food' : 'Filazero'
  }

  get businessUnitType () {
    return isFood() ? 'Restaurante' : 'Estabelecimento'
  }

  get invoiceType () {
    return isFood() ? 'Comanda' : 'Compra'
  }

  @State
  readonly businessUnit!: BusinessUnit | null

  @Getter('ordering/ordersByInvoiceId')
  readonly ordersByInvoiceId!: (id: number) => Order[]

  @Getter('ordering/invoiceLocations')
  readonly invoiceLocations!: (invoice: Invoice) => string[] | null

  @Getter('ordering/orderLocations')
  readonly orderLocations!: (order: Order) => string[] | null

  created () {
    this.$nextTick(() => {
      const pageClasses = document.getElementsByTagName('html')[0].classList
      pageClasses.add('print-receipt-global')
    })
  }

  beforeDestroy () {
    const pageClasses = document.getElementsByTagName('html')[0].classList
    pageClasses.remove('print-receipt-global')
  }

  hasPortion (item: OrderItem) {
    return item.portion !== null
  }

  isCanceled (order: Order): boolean {
    return order.status === OrderStatus.CANCELED
  }

  itemKey (order: Order, item: OrderItem, index: number) {
    const repeated = order.items.filter((i) => i.id === item.id).length > 1

    return `${order.id}_${item.id}${repeated ? `_${index}` : ''}`
  }

  optionKey (order: Order, item: OrderItem, option: OrderOption, field: string): string {
    return `${order.id}__${item.id}_${item.quantity}_${item.total}__${option.id}__${field}`
  }
}
